<template>
  <div class="container">
    <div
      class="story-status text-center d-flex flex-column align-center justify-center"
    >
      <img
        class="story-status__icon mb-3"
        :src="require('@/assets/icons/' + icon)"
      />
      <h4 class="regular-action-heading story-status__title mb-2">
        {{ status }}
      </h4>
      <span class="story-status__subtitle">
        {{ updated }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "StoryListItemStatus",
  props: {
    icon: String,
    status: String,
    updated: String,
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
}

.story-status {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  border: solid 2px var(--v-background-base);
}

.story-status__icon {
  height: 24px;
  width: auto;
}

.story-status__subtitle {
  overflow: hidden;
  color: var(--v-primaryText-base);
  font-size: 12px;
  font-weight: 400;
  line-height: 140%; /* 16.8px */
}
</style>
